<script>
  import Tile from '@components/Tile';
  import Select from '@components/Select'
  import { store, bindAction } from '@store';
  import { onDestroy } from 'svelte';
  import { putBackground, backgroundSelector, urlSelector } from '@ducks/layout'
  import SwiperBox from '@components/SwiperBox'
  import { NewsSlideOptions } from '@config'
  import InfinityScroll from '@components/InfinityScroll'
  let url
  export let list, sectionMenu, title, background, news, newsTitle, path, type, showGos;
  //
  // onDestroy(() => {
  //   if (type === 'as_exhibitions') {
  //     bindAction(putBackground)(null)
  //   }
  // })
  $: url = urlSelector($store)

  console.log(list);
</script>
<div class="header" class:dark={background}>
  <div class="margin-wrapper d-flex justify-content-between align-items-center">
    {#if title}
      <div class="title">
        <span>{title}</span>
      </div>
    {/if}
    {#if sectionMenu.length}
      <div class="filter d-flex align-items-center">
        <ul class="list align-items-center list-unstyled d-none d-xl-flex">
          {#each sectionMenu as { link, title }}
            <li class="list-item"><a href={link} class:active={path === link}>{title}</a></li>
          {/each}
        </ul>
        <div class="d-xl-none select-container mt-2 mt-sm-0">
          <Select data={sectionMenu} selectedTitle={url} />
        </div>
      </div>
    {/if}
  </div>
</div>
<div class="content">
  <InfinityScroll>
    <div class="row">
        {#if list.length}
          {#each list as { size, cover, title, link, from, to, id, listim_id, timeDate } (id) }
            <div
              class='tile-container col-6 col-sm-4 col-xl-2 {size === 'small' && 'col-xl-2'}'
            class:as_collections="{type === 'as_collections'}"
            class:as_exhibitions="{type === 'as_exhibitions'}"
            class:col-xl-4="{size === 'big' || type === 'as_collections'}"
            >
              <Tile
                img={cover}
                description={type === 'as_exhibitions' ? title : false}
              title={type === 'as_collections' ? title : false}
              href={link}
              alt={title}
              box={type === 'as_exhibitions'}
              dateFrom={from}
              dateTo={to}
              {listim_id}
              {timeDate}
              hoverType={background ? 'scale' : 'paddings'}
              />
            </div>
          {/each}
        {/if}
    </div>
  </InfinityScroll>
  {#if type === 'as_collections' && showGos}
    <section class="info hideOnTerminal">
      <a href="https://goskatalog.ru">СМОТРЕТЬ ЕЩЁ КОЛЛЕКЦИИ НА ГОСКАТАЛОГ.РФ</a>
    </section>
  {/if}
  {#if type === 'as_collections'}
    {#if news.length}
      <section class="news">
        <SwiperBox
          title={newsTitle}
          options={NewsSlideOptions}
        >
          {#each news as { title, link, desc, pub_date, cover, type_title  }}
            <div class="swiper-slide">
              <Tile
                {title}
                href={link}
                img={cover}
              />
            </div>
          {/each}
        </SwiperBox>
      </section>
    {/if}
  {/if}
</div>

<style>
  .header {
    color: white;
    padding-bottom: 25px;
    padding-top: 100px;
    margin: 0 -100px;
    border-bottom: 1px solid rgba(196, 196, 196, 0.5);
    @media (max-width: 767px) {
      margin: 0 -15px;
      padding-top: 0;
    }
    .margin-wrapper {
      margin: 0 100px;
      @media (max-width: 767px) {
        margin: 0 15px;
        flex-direction: column;
      }
    }
  }
  .header.dark {
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    .title {
        color: white;
    }
  }
  .content {
    margin-top: 70px;
    .info {
      max-width: 230px;
      margin-bottom: 100px;
      a {
        line-height: 1.375rem;
        font-size: 0.875rem;
        letter-spacing: 0.05em;
        text-decoration-line: underline;
        color: #949494;
      }
    }
    .news {
      margin-bottom: 100px;
    }
  }
  .title {
    text-transform: uppercase;
    font-size: 1.25rem;
    color: black;
  }
  .list-item {
    font-size: 1.125rem;
    &:not(:last-child) {
      margin-right: 40px;
    }
    a {
      text-decoration: none;
      color: rgba(255, 255, 255, 0.5);
    }
    a.active {
      color: rgba(255, 255, 255, 1);
    }
  }
  .tile-container.as_exhibitions {
    margin-bottom: 140px;
    @media (max-width: 767px) {
      margin-bottom: 35px;
    }
  }
  .tile-container.as_collections {
    margin-bottom: 70px;
    @media (max-width: 767px) {
      margin-bottom: 35px;
    }
  }

  .filter {
    @media (max-width: 767px) {
      width: 100%;
    }
    .select-container {
      @media (max-width: 767px) {
        width: 100%;
      }
      width: 250px;
    }
  }


</style>
